var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"street-directory"}},_vm._l((_vm.streets),function(street){return _c('StreetEntry',{key:street.id,attrs:{"street":street,"active":String(_vm.chosenStr) === String(street.id),"deselected":_vm.chosenStr && String(_vm.chosenStr) !== String(street.id)},nativeOn:{"click":function($event){return _vm.chooseStreet(street.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }